import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import MessageType from '../../../enums/MessageType';

const initialState: any = MessageType;

export const snackBarMessageTypeSlice = createSlice({
 name: 'snackBarMessageType',
 initialState: initialState,
 reducers: {
  setSnackBarMessageType: (state, action: PayloadAction<MessageType>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { setSnackBarMessageType } = snackBarMessageTypeSlice.actions;

export default snackBarMessageTypeSlice.reducer;
